module.exports = __webpack_public_path__ + "7ffdc0aa.png";